import shopinstance from "./util/shop_util";

const shopServer = {
    // 新增商品
    async AddGoods(formData){
        const response = await shopinstance.post("/add", formData,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return response.data;
    },

    // 修改商品
    async UpdateGoods(formData){
        const response = await shopinstance.put("", formData,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return response.data;
    },

    // 获取商品
    async GetGoods(){
        try{
            const response = await shopinstance.get("")
            return response.data;
        }catch(error){
            console.log(error)
        }
    },

    // 获取商品种类
    async GetGoodsType(){
        try{
            const response = await shopinstance.get("/type")
            return response.data; 
        }catch(error){
            console.log(error)
        }
    },

    async GetGoodKindType(KindName){
        try{
            const response = await shopinstance.get('/Kindtype',{params:{KindName}})
            return response.data;
        }catch(error){
            console.log(error)
        }
    },

    // 删除商品
    async DelGoods(Goodsid){
        const response = await shopinstance.delete(`/${Goodsid}`)
        return response.data;
    },

}

export default shopServer